//
//
//
//
//
//
//
//
//
//
//
//

import ContactForm from './_components/ContactForm';

export default {
  name: 'ContactUs',
  components: { ContactForm },
  head() {
    return {
      title: '聯絡STEP1NE - 人力資源與職業發展解決方案',
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: '與STEP1NE聯繫 - 您的人力資源合作夥伴',
        },
        {
          hid: 'description',
          name: 'description',
          content:
            '聯絡STEP1NE以探索我們的專業人力資源服務和職業發展方案。無論您是尋找人才，還是尋求職業機會，我們都在此協助您。',
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content:
            '聯絡STEP1NE以探索我們的專業人力資源服務和職業發展方案。無論您是尋找人才，還是尋求職業機會，我們都在此協助您。',
        },
      ],
    };
  },
};
